// config.js - Configuration loader for Promisora website

// Load environment variables
function loadEnv() {
  const env = {
    FIREBASE_API_KEY: process.env.FIREBASE_API_KEY || "default-key",
    FIREBASE_AUTH_DOMAIN: process.env.FIREBASE_AUTH_DOMAIN || "default-auth-domain",
    FIREBASE_PROJECT_ID: process.env.FIREBASE_PROJECT_ID || "default-project-id",
    FIREBASE_STORAGE_BUCKET: process.env.FIREBASE_STORAGE_BUCKET || "default-storage-bucket",
    FIREBASE_MESSAGING_SENDER_ID: process.env.FIREBASE_MESSAGING_SENDER_ID || "default-sender-id",
    FIREBASE_APP_ID: process.env.FIREBASE_APP_ID || "default-app-id",
    FIREBASE_MEASUREMENT_ID: process.env.FIREBASE_MEASUREMENT_ID || "default-measurement-id",
    NODE_ENV: process.env.NODE_ENV || "development",
    API_URL: process.env.API_URL || "http://localhost:3000/api",
    INACTIVITY_TIMEOUT: parseInt(process.env.INACTIVITY_TIMEOUT, 10) || 900000,
    AGREEMENT_PRICE_KEY: process.env.AGREEMENT_PRICE_KEY || "default-price-key",
    STRIPE_API_KEY: process.env.STRIPE_API_KEY || "default-stripe-key",
    RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY || "default-recaptcha-key"
  };

  const requiredKeys = [
    "FIREBASE_API_KEY",
    "FIREBASE_AUTH_DOMAIN",
    "FIREBASE_PROJECT_ID",
    "STRIPE_API_KEY",
    "RECAPTCHA_SITE_KEY"
  ];
  requiredKeys.forEach(key => {
    if (!env[key] || env[key].startsWith("default-")) {
      if (env.NODE_ENV === "production") {
        throw new Error(`Critical config error: ${key} is missing or invalid`);
      } else {
      }
    }
  });

  return env;
}

// Export the config
export const config = loadEnv();

// Firebase config specifically formatted for Firebase initialization
export const firebaseConfig = {
  apiKey: config.FIREBASE_API_KEY,
  authDomain: config.FIREBASE_AUTH_DOMAIN,
  projectId: config.FIREBASE_PROJECT_ID,
  storageBucket: config.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: config.FIREBASE_MESSAGING_SENDER_ID,
  appId: config.FIREBASE_APP_ID,
  measurementId: config.FIREBASE_MEASUREMENT_ID
};

export const recaptchaSiteKey = config.RECAPTCHA_SITE_KEY;

export const stripeConfig = {
  agreementPriceKey: config.AGREEMENT_PRICE_KEY,
  stripeApiKey: config.STRIPE_API_KEY
};

// Function to check if we're in dev mode
export function isDevMode() {
  // Check URL parameter first
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("dev") === "true") return true;

  // Check localStorage second
  if (localStorage.getItem("devMode") === "true") return true;

  // Finally check environment
  return config.NODE_ENV === "development";
}

// For debugging only - don't use in production
export function printConfig() {
  if (isDevMode()) {
    return {
      environment: config.NODE_ENV,
      apiUrl: config.API_URL,
      firebaseProjectId: config.FIREBASE_PROJECT_ID,
      inactivityTimeout: config.INACTIVITY_TIMEOUT
    };
  }
  return null;
}